export default "__VITE_PUBLIC_ASSET__df50e3e2__"